var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"dingButton",class:[
    _vm.buttonSize ? `ding-btn-${_vm.buttonSize}` : '',
    {
      'is-disabled': _vm.disabled,
      'is-plain': _vm.plain,
      'is-disabled-plain': _vm.disabled && _vm.plain
    }
  ],attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.content)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }